import {DspFluxExportCard} from './DspFluxExportCard'
import {MergeReportsCard} from './MergeReportsCard'
import {StyledCardsRow} from './style'

// Operational cards shown directly under the page header: extract the DSP Flux archive and
// (placeholder) merge correlated reports — both without selecting any table row.
export const ActivityReportExportCards = () => (
    <StyledCardsRow>
        <DspFluxExportCard />
        <MergeReportsCard />
    </StyledCardsRow>
)
